import React, { useState } from "react";
import Login from "./Login";
import Phonenologin from "./Phonenologin";

const Signinoption = (props) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showMobileModal, setShowMobileModal] = useState(false);

  const openLoginModal = () => {
    showLoginModal ? setShowLoginModal(false) : setShowLoginModal(true);
  };

  const openMobileModal = () => {
    showMobileModal ? setShowMobileModal(false) : setShowMobileModal(true);
  };

  return (
    <>
      <div
        className="relative z-50"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >

        <div className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur transition-opacity"></div>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="relative bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] rounded-lg shadow dark:bg-gray-700 py-2">
              <div className="bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] p-2">
                <div className="sm:flex sm:items-start">
                <div className="p-2">
                    <h1 className="text-xl font bold text-white py-3">
                      Select one of the following Sign In Options
                    </h1>
                    <div
                      className="flex gap-4 hover:cursor-pointer"
                      onClick={openLoginModal}
                      // data-modal-target="email-modal"
                      // data-modal-toggle="email-modal"
                      // data-modal-hide="option-modal"
                    >
                      <h1 className="text-lg font my-auto bold text-left text-white">
                        Login with Email
                      </h1>
                    </div>
                    <div
                      className="flex gap-4 mt-2 hover:cursor-pointer"
                      onClick={openMobileModal}

                      // data-modal-target="mobile-modal"
                      // data-modal-toggle="mobile-modal"
                      // data-modal-hide="option-modal"
                    >
                      <h1 className="text-lg font my-auto bold text-left text-white">
                        Login with Mobile Number
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
              <button
                onClick={props.modalSigninClose}
                type="button"
                className="mx-4 my-2 w-[90%] text-center rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 "

              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>


      {showLoginModal ? (
        <Login
          modalLoginClose={() => {
            openLoginModal();
            props.modalSigninClose();

          }}
        />
      ) : (
        ""
      )}

      {showMobileModal ? (
        <Phonenologin
          modalMobileClose={() => {
            openMobileModal();
            props.modalSigninClose();
          }}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default Signinoption;

